var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsMarkasresolvedEnabled24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2658 16.8364C10.0432 16.8357 9.83087 16.7426 9.6795 16.5794L5.77629 12.4272C5.47246 12.1034 5.48864 11.5946 5.81243 11.2908C6.13623 10.987 6.64503 11.0031 6.94886 11.3269L10.2578 14.8527L17.0121 7.46388C17.1988 7.23131 17.4991 7.1214 17.7919 7.17846C18.0847 7.23551 18.3217 7.45013 18.4075 7.73581C18.4933 8.0215 18.4136 8.33119 18.2007 8.54007L10.8601 16.5714C10.7101 16.7375 10.4976 16.8336 10.2738 16.8364H10.2658Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.5H8C5.51472 3.5 3.5 5.51472 3.5 8V16C3.5 18.4853 5.51472 20.5 8 20.5H16C18.4853 20.5 20.5 18.4853 20.5 16V8C20.5 5.51472 18.4853 3.5 16 3.5ZM8 2C4.68629 2 2 4.68629 2 8V16C2 19.3137 4.68629 22 8 22H16C19.3137 22 22 19.3137 22 16V8C22 4.68629 19.3137 2 16 2H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsMarkasresolvedEnabled24);
export default __webpack_public_path__ + "static/media/actions-mark as resolved-enabled-24.66d92c29de4ed621cf764a360cfe878d.svg";
export { ForwardRef as ReactComponent };